import { render, staticRenderFns } from "./DxListManage.vue?vue&type=template&id=06a5834e&scoped=true"
import script from "./DxListManage.vue?vue&type=script&lang=js"
export * from "./DxListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a5834e",
  null
  
)

export default component.exports